import React, { useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  PAGINATION_DEFAULT,
} from '../../../utils/constants';
import DataTable from '../../datatable';
import { useGetBranchDepartments } from '../../../redux/human-resources/hook/branches';

const BranchDepartmentTab = () => {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  
  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    search: '',
  });
  const { id } = useParams();

  const { data: branch_departments } = useGetBranchDepartments(
    id,
    pagination?.limit,
    pagination?.page,
    pagination?.search,
  );

  const tableConfig = {
    headers: ['Date Added', 'Branch Name', 'Department Name'],
    keys: ['created', 'branch_name', 'department_name'],
    mobileHeader: {
      left: {
        title: 'Date Added',
        key: 'created',
      },
      right: {
        title: 'Department Name',
        key: 'department_name',
      },
    },
  };

  return (
    <div className='flex flex-col bg-white shadow-md rounded-md'>
      <div className='flex flex-col md:flex-row justify-between items-center px-4 gap-[10px] my-2 mt-3'>
        <div className='p3-bold header-4'>
          Departments
        </div>
      </div>
      <hr className='divider mt-2' />
      <DataTable
        data={branch_departments}
        tableConfig={tableConfig}
        updatePagination={(data) => setPagination(data)}
        searchData={true}
        noCheck={true}
      />
    </div>
  );
};

export default BranchDepartmentTab;
